import React from "react";
import { Menu, Select } from "@sscs/ui";
const VulnerabilitySeverityFilter = ({ value, onChange, className, ...props }) => {
    var _a;
    return (React.createElement(Select, { id: "filter-by-severity", labelId: "severity-filter-label", label: "Filter by severity", onChange: onChange, value: value, displayEmpty: true, shrinkLabel: true, className: className, "data-filtered-by-link": (_a = props["data-filtered-by-link"]) !== null && _a !== void 0 ? _a : false },
        React.createElement(Menu.Item, { id: "show-all-severity-vulnerabilities", value: "ALL" }, "Show all severities"),
        React.createElement(Menu.Item, { id: "critical-severity", value: "critical" }, "Critical"),
        React.createElement(Menu.Item, { id: "high-severity", value: "high" }, "High"),
        React.createElement(Menu.Item, { id: "medium-severity", value: "medium" }, "Medium"),
        React.createElement(Menu.Item, { id: "low-severity", value: "low" }, "Low")));
};
export default VulnerabilitySeverityFilter;
//# sourceMappingURL=VulnerabilitySeverityFilter.js.map